module.exports = __webpack_public_path__ + "img/vue2-languette_rose.2097d251.png";